import { getEnterpriseCustomerList, getPersonalCustomerList } from '@/api/domain/customers'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { enterpriseCustomerTemplate, individualCustomerTemplate } from '@/config'
import { operateMaxShowLength } from '@/store/dict/config'
import dict from '@/store/dict/selectOptionDict'

const { isHaveList, customerSourceList } = dict

// 客户类型
export const CUSTOMER_TYPE = {
  company: 'company',
  person: 'person',
}

// 客户配置
export const CUSTOMER_CONFIG = {
  [CUSTOMER_TYPE.person]: {
    label: '个人客户',
    value: 1,
    ref: 'personRef',
    importLabel: '个人',
    importImgTypes: [
      {
        label: '身份证人像面',
        value: 10,
      },
      {
        label: '身份证国徽面',
        value: 13,
      },
      {
        label: '驾驶证正页',
        value: 11,
      },
      {
        label: '驾驶证副页',
        value: 14,
      },
      {
        label: '网约车驾驶员证',
        value: 12,
      },
    ],
    importCtmTpl: individualCustomerTemplate,
  },
  [CUSTOMER_TYPE.company]: {
    label: '企业客户',
    value: 2,
    ref: 'companyRef',
    importLabel: '企业',
    importImgTypes: [{
      label: '营业执照',
      value: 20,
    }],
    importCtmTpl: enterpriseCustomerTemplate,
  },
}

// 筛选项&表格配置
export function configFn() {
  return {
    [CUSTOMER_TYPE.person]: {
      configData: {
        formData: {
          formProps: {
            model: {
              customerType: CUSTOMER_CONFIG[CUSTOMER_TYPE.person].value,
            },
          },
          list: [{
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'id',
            },
            elConfig: {
              placeholder: '请输入',
              remote: true,
              clearable: true,
              filterable: true,
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              remoteMethod: (query) => this.searchCustomers(CUSTOMER_TYPE.person, query),
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                change: () => {
                  const customerItem = this.personConfig.formData.list.find((item) => item.itemConfig.prop === 'id')
                  this.customerConditionList = customerItem?.elConfig?.options?.list
                },
              },
            },
          }, {
            el: 'input',
            itemConfig: {
              label: '客户手机号',
              prop: 'customerTel',
            },
            elConfig: {
              clearable: true,
              placeholder: '请输入手机号',
            },
            directives: [{ name: 'number', arg: 'phone' }],
          }, {
            el: 'input',
            itemConfig: {
              label: '身份证号',
              prop: 'idCardNo',
            },
            elConfig: {
              clearable: true,
              placeholder: '请输入身份证号',
            },
            directives: [{ name: 'number', arg: 'idCard' }],
          }, {
            el: 'select',
            itemConfig: {
              label: '所属司管',
              prop: 'driverManagerId',
            },
            elConfig: {
              placeholder: '请选择司管人员',
              clearable: true,
              filterable: true,
              options: {
                label: 'userName',
                value: 'id',
                list: [],
              },
              events: {
                change: () => {
                  const managerItem = this.personConfig.formData.list.find((item) => item.itemConfig.prop === 'driverManagerId')
                  this.driverManagerConditionList = managerItem?.elConfig?.options?.list
                },
              },
            },
          }, {
            el: 'select',
            itemConfig: {
              label: '客户来源',
              prop: 'source',
            },
            elConfig: {
              clearable: true,
              placeholder: '请选择',
              options: {
                label: 'label',
                value: 'value',
                list: this.dictParseList(customerSourceList),
              },
            },
          }, {
            el: 'select',
            itemConfig: {
              label: '是否有网约车驾驶员证',
              prop: 'networkDriverLicense',
            },
            elConfig: {
              clearable: true,
              options: {
                label: 'label',
                value: 'value',
                list: this.dictParseList(isHaveList),
              },
            },
          }, {
            el: 'select',
            itemConfig: {
              label: '客户标签',
              prop: 'tagId',
            },
            elConfig: {
              placeholder: '请选择客户标签',
              clearable: true,
              options: {
                label: 'name',
                value: 'id',
                list: [],
              },
            },
          }, {
            el: 'select',
            itemConfig: {
              label: '所属车管',
              prop: 'vehicleManagerId',
            },
            elConfig: {
              placeholder: '请选择车管人员',
              clearable: true,
              filterable: true,
              options: {
                label: 'userName',
                value: 'id',
                list: [],
              },
              events: {
                change: () => {
                  const managerItem = this.personConfig.formData.list.find((item) => item.itemConfig.prop === 'vehicleManagerId')
                  this.carManagerConditionList = managerItem?.elConfig?.options?.list
                },
              },
            },
          }],
        },
        tableData: {
          columns: [{
            name: 'id',
            columnProps: {
              label: '客户ID',
              prop: 'id',
            },
            render: ({ row }) => {
              if (this.judgePermission('driver_customer_list_detail')) {
                return this.$createElement('span', {
                  class: 'link',
                  on: {
                    click: () => this.linkToDetail(row),
                  },
                }, row.id)
              }
              return row.id
            },
          }, {
            name: 'customerName',
            columnProps: {
              label: '客户名称',
              prop: 'customerName',
            },
          }, {
            name: 'customerTel',
            columnProps: {
              label: '客户手机号',
              prop: 'customerTel',
              width: 120,
            },
          }, {
            name: 'idCardNo',
            columnProps: {
              label: '身份证号',
              prop: 'idCardNo',
              width: '180px',
            },
          }, {
            name: 'driverManager',
            columnProps: {
              label: '所属司管',
              prop: 'driverManager',
            },
            render: ({ row }) => {
              if (row && row.driverManager) {
                return `${row.driverManager.userName}（${row.driverManager.account}）`
              }
              return '- -'
            },
          }, {
            name: 'source',
            columnProps: {
              label: '客户来源',
              prop: 'source',
            },
            render: ({ row }) => {
              return customerSourceList[row.source] || '- -'
            },
          }, {
            name: 'networkDriverLicense',
            columnProps: {
              label: '是否有网约车驾驶员证',
              prop: 'networkDriverLicense',
              width: 100,
            },
            render: ({ row }) => {
              return isHaveList[row.networkDriverLicense] || '- -'
            },
          }, {
            name: 'tagList',
            columnProps: {
              label: '客户标签',
              prop: 'tagList',
              width: 120,
            },
            render: ({ row }) => {
              if (row && row.tagList) {
                return row.tagList.map((item) => {
                  return this.$createElement('el-tag', { size: 'mini' }, item)
                })
              }
              return '- -'
            },
          }, {
            name: 'vehicleManager',
            columnProps: {
              label: '所属车管',
              prop: 'vehicleManager',
            },
            render: ({ row }) => {
              if (row && row.vehicleManager) {
                return `${row.vehicleManager.userName}（${row.vehicleManager.account}）`
              }
              return '- -'
            },
          }, {
            name: 'gmtCreate',
            columnProps: {
              label: '创建时间',
              prop: 'gmtCreate',
              width: 160,
            },
          }, {
            name: 'gmtModified',
            columnProps: {
              label: '最后一次更新时间',
              prop: 'gmtModified',
              width: 160,
            },
          }, {
            name: 'operate',
            columnProps: {
              label: '操作',
              fixed: 'right',
              width: 240,
            },
            maxShowLength: operateMaxShowLength,
            getOperateList: ({ row }) => {
              const btns = []
              if (this.judgePermission('driver_customer_list_edit')) {
                btns.push({
                  name: 'edit',
                  label: '编辑',
                  action: () => this.editHandle(row),
                })
              }
              return btns
            },
            type: 'operate',
          }],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getPersonalCustomerList,
        },
        isShowDepartment: false,
      },
    },
    [CUSTOMER_TYPE.company]: {
      configData: {
        formData: {
          formProps: {
            model: {
              customerType: CUSTOMER_CONFIG[CUSTOMER_TYPE.company].value,
            },
          },
          list: [{
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'id',
            },
            elConfig: {
              placeholder: '请输入关键词',
              remote: true,
              clearable: true,
              filterable: true,
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              remoteMethod: (query) => this.searchCustomers(CUSTOMER_TYPE.company, query),
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                change: () => {
                  const customerItem = this.companyConfig.formData.list.find((item) => item.itemConfig.prop === 'id')
                  this.customerConditionList = customerItem?.elConfig?.options?.list
                },
              },
            },
          }, {
            el: 'input',
            itemConfig: {
              label: '统一社会信用代码证号',
              prop: 'creditCode',
            },
            elConfig: {
              placeholder: '请输入',
              maxlength: 18,
            },
          }, {
            el: 'input',
            itemConfig: {
              label: '联系电话',
              prop: 'customerTel',
            },
            elConfig: {
              clearable: true,
              placeholder: '请输入手机号',
            },
            directives: [{ name: 'number', arg: 'phone' }],
          }, {
            el: 'select',
            itemConfig: {
              label: '客户标签',
              prop: 'tagId',
            },
            elConfig: {
              placeholder: '请选择客户标签',
              clearable: true,
              options: {
                label: 'name',
                value: 'id',
                list: [],
              },
            },
          }],
        },
        tableData: {
          columns: [{
            name: 'id',
            columnProps: {
              label: '客户ID',
              prop: 'id',
            },
            render: ({ row }) => {
              if (this.judgePermission('driver_customer_list_detail')) {
                return this.$createElement('span', {
                  class: 'link',
                  on: {
                    click: () => this.linkToDetail(row),
                  },
                }, row.id)
              }
              return row.id
            },
          }, {
            name: 'customerName',
            columnProps: {
              label: '客户名称',
              prop: 'customerName',
            },
          }, {
            name: 'creditCode',
            columnProps: {
              label: '统一社会信用代码证号',
              prop: 'creditCode',
            },
          }, {
            name: 'customerTel',
            columnProps: {
              label: '联系电话',
              prop: 'customerTel',
              width: 120,
            },
          }, {
            name: 'tagList',
            columnProps: {
              label: '客户标签',
              prop: 'tagList',
            },
            render: ({ row }) => {
              if (row && row.tagList) {
                return row.tagList.map((item) => {
                  return this.$createElement('el-tag', { size: 'mini' }, item)
                })
              }
              return '- -'
            },
          }, {
            name: 'gmtCreate',
            columnProps: {
              label: '创建时间',
              prop: 'gmtCreate',
              width: 160,
            },
          }, {
            name: 'gmtModified',
            columnProps: {
              label: '最后一次更新时间',
              prop: 'gmtModified',
              width: 160,
            },
          }, {
            name: 'operate',
            columnProps: {
              label: '操作',
              fixed: 'right',
              width: 240,
            },
            maxShowLength: operateMaxShowLength,
            getOperateList: ({ row }) => {
              const btns = []
              if (this.judgePermission('driver_customer_list_edit')) {
                btns.push({
                  name: 'edit',
                  label: '编辑',
                  action: () => this.editHandle(row),
                })
              }
              return btns
            },
            type: 'operate',
          }],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getEnterpriseCustomerList,
        },
        isShowDepartment: false,
      },
    },
  }
}

// 导入类型
export const IMPORT_TYPE = {
  // 证照导入
  IMG: 'IMG',
  // 客户导入
  CTM: 'CTM',
}

// 导入配置
export const IMPORT_CONFIG = {
  [IMPORT_TYPE.IMG]: {
    title: '客户证照',
    // 上传证照校验规则
    rules: {
      type: [{ required: true, message: '证照类型不能为空' }],
      fileList: [{ required: true, trigger: 'blur' }],
    },
    // 上传文件标签
    label: '上传压缩文件包：',
    // 导入任务链接
    taskLink: '/logCenter/importCustomerLisenceLog/list',
  },
  [IMPORT_TYPE.CTM]: {
    title: '信息',
    // 上传客户信息校验规则
    rules: {
      fileList: [{ required: true, trigger: 'blur' }],
    },
    label: '上传客户信息：',
    taskLink: '/logCenter/importCustomerLog/list',
  },
}
